import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EducationItem = _resolveComponent("EducationItem")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.educations && _ctx.educations.length)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          class: "pt-6 align-item-s"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educations, (item, index) => {
              return (_openBlock(), _createBlock(_component_v_col, {
                xs: "12",
                sm: "12",
                lg: "6",
                key: 'row_' + index
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_EducationItem, {
                    education: item,
                    onEdit: ($event: any) => (_ctx.edit(item)),
                    onRemove: ($event: any) => (_ctx.remove(item)),
                    isHiringmanager: _ctx.isHiringmanager
                  }, null, 8, ["education", "onEdit", "onRemove", "isHiringmanager"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_v_row, {
          key: 1,
          class: "pt-16 pb-16 mt-16"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { class: "text-center" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h2", null, "You can see added educations here", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }))
  ]))
}